const CAREER_ASSETS_CDN_URL = 'https://static.cdn-cian.ru/frontend/job-vacancies-assets/images';

const getCareerAssetUrl = (fileName: string): string => `${CAREER_ASSETS_CDN_URL}/${fileName}`;

export const maonHeroGirlImage = getCareerAssetUrl('maon_hero_girl-image.webp');
export const maonHeroGirlImageP500 = getCareerAssetUrl(
  '7e0e333e8340a6f8383ba3d3bd48a087_maon_hero_girl-image-p-500.webp',
);
export const maonHeroGirlImageP800 = getCareerAssetUrl(
  '7e0e333e8340a6f8383ba3d3bd48a087_maon_hero_girl-image-p-800.webp',
);
export const maonHeroGirlImageP1080 = getCareerAssetUrl(
  '7e0e333e8340a6f8383ba3d3bd48a087_maon_hero_girl-image-p-1080.webp',
);
export const maonHeroGirlImageP1600 = getCareerAssetUrl(
  '7e0e333e8340a6f8383ba3d3bd48a087_maon_hero_girl-image-p-1600.webp',
);
export const mainSystemTopBgImage = getCareerAssetUrl('main_system_top-bg-image.svg');
export const mainSystemGirlImage = getCareerAssetUrl('main_system_girl-image.webp');
export const mainSystemTooltipImage = getCareerAssetUrl('main_system_tooltip-image.webp');
export const mainSystemTooltipImageP500 = getCareerAssetUrl(
  'da012c971dbd2245aaf15fa1f6298a63_main_system_tooltip-image-p-500.webp',
);
export const mainSystemTooltipImageP800 = getCareerAssetUrl(
  'da012c971dbd2245aaf15fa1f6298a63_main_system_tooltip-image-p-800.webp',
);
export const mainSystemTooltipImageP1080 = getCareerAssetUrl(
  'da012c971dbd2245aaf15fa1f6298a63_main_system_tooltip-image-p-1080.webp',
);
export const mainTeamMouseImage = getCareerAssetUrl('main_team_mouse-image.webp');
export const mainTeamMouseImageP500 = getCareerAssetUrl(
  'b72d63780247aa9a875281ed0c0d19ee_main_team_mouse-image-p-500.webp',
);
export const mainTeamMouseImageP800 = getCareerAssetUrl(
  'b72d63780247aa9a875281ed0c0d19ee_main_team_mouse-image-p-800.webp',
);
export const mainTeamMouseImageP1080 = getCareerAssetUrl(
  'b72d63780247aa9a875281ed0c0d19ee_main_team_mouse-image-p-1080.webp',
);
export const mainTeamDuckImage = getCareerAssetUrl('main_team_duck-image.webp');
export const mainTeamDuckImageP500 = getCareerAssetUrl(
  'c986cb3ceb85e95c5f58b81bc72b8e2d_main_team_duck-image-p-500.webp',
);
export const mainTeamHeartImage = getCareerAssetUrl('main_team_heart-image.webp');
export const mainTeamHeartImageP500 = getCareerAssetUrl(
  'bc190e0fc001f4e1fd690346749970f6_main_team_heart-image-p-500.webp',
);
export const mainTeamStarImage = getCareerAssetUrl('main_team_star-image.webp');
export const mainTeamSmileImage = getCareerAssetUrl('main_team_smile-image.webp');
export const mainTeamSmileImageP500 = getCareerAssetUrl(
  'e2a34a08d282b82dd5fe3d567272de6a_main_team_smile-image-p-500.webp',
);
export const mainTeamMobileMouseImage = getCareerAssetUrl('main_team_mobile-mouse-image.webp');
export const mainPeopleBgImageConverted = getCareerAssetUrl('main_people_bg-image_converted.webp');
export const mainPeopleCardImageIsNatalia = getCareerAssetUrl('main_people_card-image_is-natalia.webp');
export const mainPeopleCardImageIsNataliaP500 = getCareerAssetUrl(
  '78728ce37c969820b56d4cf9249f6931_main_people_card-image_is-natalia-p-500.webp',
);
export const mainPeopleCardImageIsNataliaP800 = getCareerAssetUrl(
  '78728ce37c969820b56d4cf9249f6931_main_people_card-image_is-natalia-p-800.webp',
);
export const mainPeopleCardImageIsNikita = getCareerAssetUrl('main_people_card-image_is-nikita.webp');
export const mainPeopleCardImageIsNikitaP500 = getCareerAssetUrl(
  'deedb0c392ed9ed52f78a06d5471e3d2_main_people_card-image_is-nikita-p-500.webp',
);
export const mainPeopleCardImageIsNikitaP800 = getCareerAssetUrl(
  'deedb0c392ed9ed52f78a06d5471e3d2_main_people_card-image_is-nikita-p-800.webp',
);
export const mainPeopleCardImageIsVeronica = getCareerAssetUrl('main_people_card-image_is-veronica.webp');
export const mainPeopleCardImageIsVeronicaP500 = getCareerAssetUrl(
  '2307315b50a12eeb86b72c018bc11e2e_main_people_card-image_is-veronica-p-500.webp',
);
export const mainPeopleCardImageIsVeronicaP800 = getCareerAssetUrl(
  '2307315b50a12eeb86b72c018bc11e2e_main_people_card-image_is-veronica-p-800.webp',
);
export const mainPeopleCardImageIsDanil = getCareerAssetUrl('main_people_card-image_is-danil.webp');
export const mainPeopleCardImageIsDanilP500 = getCareerAssetUrl(
  'b8abc6a706ed973292ec31b9acde82fd_main_people_card-image_is-danil-p-500.webp',
);
export const mainPeopleCardImageIsDanilP800 = getCareerAssetUrl(
  'b8abc6a706ed973292ec31b9acde82fd_main_people_card-image_is-danil-p-800.webp',
);
export const mainPeopleCardImageIsDima = getCareerAssetUrl('main_people_card-image_is-dima.webp');
export const mainPeopleCardImageIsDimaP500 = getCareerAssetUrl(
  '4177f531bec9def4f37edae88f573ac0_main_people_card-image_is-dima-p-500.webp',
);
export const mainPeopleCardImageIsDimaP800 = getCareerAssetUrl(
  '4177f531bec9def4f37edae88f573ac0_main_people_card-image_is-dima-p-800.webp',
);
export const mainVacanciesBoyImage = getCareerAssetUrl('main_vacancies_boy-image.webp');
export const mainVacanciesBoyImageP500 = getCareerAssetUrl(
  'f6cb5665bf584e34ba424bf0a68ebdae_main_vacancies_boy-image-p-500.webp',
);
export const mainVacanciesBoyImageP800 = getCareerAssetUrl(
  'f6cb5665bf584e34ba424bf0a68ebdae_main_vacancies_boy-image-p-800.webp',
);
export const mainVacanciesBoyImageP1080 = getCareerAssetUrl(
  'f6cb5665bf584e34ba424bf0a68ebdae_main_vacancies_boy-image-p-1080.webp',
);
export const mainVacanciesBoyImageP1600 = getCareerAssetUrl(
  'f6cb5665bf584e34ba424bf0a68ebdae_main_vacancies_boy-image-p-1600.webp',
);
export const mainVacanciesPhoto1 = getCareerAssetUrl('main_vacancies_photo-1.webp');
export const mainVacanciesPhoto1P500 = getCareerAssetUrl(
  '727e06ef85a05b95511e83030fde4d44_main_vacancies_photo-1-p-500.webp',
);
export const mainVacanciesPhoto1P800 = getCareerAssetUrl(
  '727e06ef85a05b95511e83030fde4d44_main_vacancies_photo-1-p-800.webp',
);
export const mainVacanciesPhoto2 = getCareerAssetUrl('main_vacancies_photo-2.webp');
export const mainVacanciesPhoto2P500 = getCareerAssetUrl(
  'e6eedaeee0ddbab4cfcc0a4493f9df2a_main_vacancies_photo-2-p-500.webp',
);
export const mainVacanciesPhoto2P800 = getCareerAssetUrl(
  'e6eedaeee0ddbab4cfcc0a4493f9df2a_main_vacancies_photo-2-p-800.webp',
);
export const mainVacanciesPhoto3 = getCareerAssetUrl('main_vacancies_photo-3.webp');
export const mainVacanciesPhoto3P500 = getCareerAssetUrl(
  'c76721ea988178939705a239b4454d46_main_vacancies_photo-3-p-500.webp',
);
export const mainVacanciesPhoto3P800 = getCareerAssetUrl(
  'c76721ea988178939705a239b4454d46_main_vacancies_photo-3-p-800.webp',
);
export const mainOfferStar1 = getCareerAssetUrl('main_offer_star-1.webp');
export const mainOfferStar1P500 = getCareerAssetUrl('f59d3b2edbdb34b1f0cee85454774234_main_offer_star-1-p-500.webp');
export const mainOfferStar1P800 = getCareerAssetUrl('f59d3b2edbdb34b1f0cee85454774234_main_offer_star-1-p-800.webp');
export const mainOfferStar1P1080 = getCareerAssetUrl('f59d3b2edbdb34b1f0cee85454774234_main_offer_star-1-p-1080.webp');
export const mainDrivePhoto1 = getCareerAssetUrl('main_drive_photo-1.webp');
export const mainDrivePhoto1P500 = getCareerAssetUrl('ab188f20f310c0031cfada5314a045cc_main_drive_photo-1-p-500.webp');
export const mainDrivePhoto1P800 = getCareerAssetUrl('ab188f20f310c0031cfada5314a045cc_main_drive_photo-1-p-800.webp');
export const mainDrivePhoto1P1080 = getCareerAssetUrl(
  'ab188f20f310c0031cfada5314a045cc_main_drive_photo-1-p-1080.webp',
);
export const mainDrivePhoto2 = getCareerAssetUrl('main_drive_photo-2.webp');
export const mainDrivePhoto2P500 = getCareerAssetUrl('ced77bec168f0512814d430def52c93e_main_drive_photo-2-p-500.webp');
export const mainDrivePhoto2P800 = getCareerAssetUrl('ced77bec168f0512814d430def52c93e_main_drive_photo-2-p-800.webp');
export const mainDrivePhoto2P1080 = getCareerAssetUrl(
  'ced77bec168f0512814d430def52c93e_main_drive_photo-2-p-1080.webp',
);
export const mainDrivePhoto2P1600 = getCareerAssetUrl(
  'ced77bec168f0512814d430def52c93e_main_drive_photo-2-p-1600.webp',
);
export const mainDrivePhoto3 = getCareerAssetUrl('main_drive_photo-3.webp');
export const mainDrivePhoto3P500 = getCareerAssetUrl('5bca3a7a17b0489a8095e78f7070bb37_main_drive_photo-3-p-500.webp');
export const mainDrivePhoto3P800 = getCareerAssetUrl('5bca3a7a17b0489a8095e78f7070bb37_main_drive_photo-3-p-800.webp');
export const mainDrivePhoto3P1080 = getCareerAssetUrl(
  '5bca3a7a17b0489a8095e78f7070bb37_main_drive_photo-3-p-1080.webp',
);
export const mainDrivePhoto4 = getCareerAssetUrl('main_drive_photo-4.webp');
export const mainDrivePhoto4P500 = getCareerAssetUrl('b1eecb4cb2ca4e232cdf21b0b3e6f8a3_main_drive_photo-4-p-500.webp');
export const mainDrivePhoto4P800 = getCareerAssetUrl('b1eecb4cb2ca4e232cdf21b0b3e6f8a3_main_drive_photo-4-p-800.webp');
export const mainDrivePhoto4P1080 = getCareerAssetUrl(
  'b1eecb4cb2ca4e232cdf21b0b3e6f8a3_main_drive_photo-4-p-1080.webp',
);
export const mainDrivePhoto5 = getCareerAssetUrl('main_drive_photo-5.webp');
export const mainDrivePhoto5P500 = getCareerAssetUrl('7e19696baa173772ea41e64e91030cdf_main_drive_photo-5-p-500.webp');
export const mainDrivePhoto5P800 = getCareerAssetUrl('7e19696baa173772ea41e64e91030cdf_main_drive_photo-5-p-800.webp');
export const mainDrivePhoto5P1080 = getCareerAssetUrl(
  '7e19696baa173772ea41e64e91030cdf_main_drive_photo-5-p-1080.webp',
);
export const mainArchitectorCardImage = getCareerAssetUrl('main_architector_card-image.webp');
export const mainArchitectorCardImageP500 = getCareerAssetUrl(
  'efe1f26e198baa75196fa79c93e6826f_main_architector_card-image-p-500.webp',
);
export const mainArchitectorCardImageP800 = getCareerAssetUrl(
  'efe1f26e198baa75196fa79c93e6826f_main_architector_card-image-p-800.webp',
);
export const mainArchitectorCardImageP1080 = getCareerAssetUrl(
  'efe1f26e198baa75196fa79c93e6826f_main_architector_card-image-p-1080.webp',
);
export const mainArchitectorCardImageP1600 = getCareerAssetUrl(
  'efe1f26e198baa75196fa79c93e6826f_main_architector_card-image-p-1600.webp',
);
export const mainArchitectorCardPuzzleImage = getCareerAssetUrl('main_architector_card-puzzle-image.webp');
export const mainArchitectorCardPuzzleImageP500 = getCareerAssetUrl(
  '845faabefb097441f6123beaab85d64d_main_architector_card-puzzle-image-p-500.webp',
);
export const mainArchitectorCardPuzzleImageP800 = getCareerAssetUrl(
  '845faabefb097441f6123beaab85d64d_main_architector_card-puzzle-image-p-800.webp',
);
export const mainArchitectorCardPuzzleImageP1080 = getCareerAssetUrl(
  '845faabefb097441f6123beaab85d64d_main_architector_card-puzzle-image-p-1080.webp',
);
export const mainBlogBikeImage = getCareerAssetUrl('main_blog_bike-image.webp');
export const mainBlogBikeImageP500 = getCareerAssetUrl('main_blog_bike-image-p-500.webp');
export const mainBlogBikeImageP800 = getCareerAssetUrl('main_blog_bike-image-p-800.webp');
export const blogImage3 = getCareerAssetUrl('3.webp');
export const blogImage3P500 = getCareerAssetUrl('3-p-500.webp');
export const blogImage3P800 = getCareerAssetUrl('3-p-800.webp');
export const blogImage3P1080 = getCareerAssetUrl('3-p-1080.webp');
export const blogImage3P1600 = getCareerAssetUrl('3-p-1600.webp');
export const blogImage1 = getCareerAssetUrl('1.webp');
export const blogImage1P500 = getCareerAssetUrl('1-p-500.webp');
export const blogImage1P800 = getCareerAssetUrl('1-p-800.webp');
export const blogImage1P1080 = getCareerAssetUrl('1-p-1080.webp');
export const blogImage1P1600 = getCareerAssetUrl('1-p-1600.webp');
export const blogImage2 = getCareerAssetUrl('2.webp');
export const blogImage2P500 = getCareerAssetUrl('2-p-500.webp');
export const blogImage2P800 = getCareerAssetUrl('2-p-800.webp');
export const blogImage2P1080 = getCareerAssetUrl('2-p-1080.webp');
export const blogImage2P1600 = getCareerAssetUrl('2-p-1600.webp');
export const blogImage5 = getCareerAssetUrl('5.webp');
export const blogImage5P500 = getCareerAssetUrl('5-p-500.webp');
export const blogImage5P800 = getCareerAssetUrl('5-p-800.webp');
export const blogImage5P1080 = getCareerAssetUrl('5-p-1080.webp');
export const blogImage5P1600 = getCareerAssetUrl('5-p-1600.webp');
export const blogImage6 = getCareerAssetUrl('6.webp');
export const blogImage6P500 = getCareerAssetUrl('6-p-500.webp');
export const blogImage6P800 = getCareerAssetUrl('6-p-800.webp');
export const blogImage6P1080 = getCareerAssetUrl('6-p-1080.webp');
export const blogImage6P1600 = getCareerAssetUrl('6-p-1600.webp');
export const blogImage4 = getCareerAssetUrl('4.webp');
export const blogImage4P500 = getCareerAssetUrl('4-p-500.webp');
export const blogImage4P800 = getCareerAssetUrl('4-p-800.webp');
export const blogImage4P1080 = getCareerAssetUrl('4-p-1080.webp');
export const blogImage4P1600 = getCareerAssetUrl('4-p-1600.webp');
export const blogImage8 = getCareerAssetUrl('8.webp');
export const blogImage8P500 = getCareerAssetUrl('8-p-500.webp');
export const blogImage8P1080 = getCareerAssetUrl('8-p-1080.webp');
export const blogImage8P1600 = getCareerAssetUrl('8-p-1600.webp');
export const blogImage7 = getCareerAssetUrl('7.webp');
export const blogImage7P500 = getCareerAssetUrl('7-p-500.webp');
export const blogImage7P800 = getCareerAssetUrl('7-p-800.webp');
export const blogImage7P1080 = getCareerAssetUrl('7-p-1080.webp');
export const blogImage7P1600 = getCareerAssetUrl('7-p-1600.webp');
export const blogImage9 = getCareerAssetUrl('9.webp');
export const blogImage9P500 = getCareerAssetUrl('9-p-500.webp');
export const blogImage9P800 = getCareerAssetUrl('9-p-800.webp');
export const blogImage9P1080 = getCareerAssetUrl('9-p-1080.webp');
export const blogImage11 = getCareerAssetUrl('11.webp');
export const blogImage11P500 = getCareerAssetUrl('11-p-500.webp');
export const blogImage11P800 = getCareerAssetUrl('11-p-800.webp');
export const blogImage11P1080 = getCareerAssetUrl('11-p-1080.webp');
export const blogImage10 = getCareerAssetUrl('10.webp');
export const blogImage10P500 = getCareerAssetUrl('10-p-500.webp');
export const blogImage10P800 = getCareerAssetUrl('10-p-800.webp');
export const blogImage10P1080 = getCareerAssetUrl('10-p-1080.webp');
export const mainFooterKeyImage = getCareerAssetUrl('main_footer_key-image.webp');
export const mainFooterKeyImageP500 = getCareerAssetUrl('main_footer_key-image-p-500.webp');
export const iconTg = getCareerAssetUrl('icon-tg.svg');
export const iconVk = getCareerAssetUrl('icon-vk.svg');
export const iconHabr = getCareerAssetUrl('icon-habr.svg');
export const iconEmail = getCareerAssetUrl('icon-email.svg');
export const mainHeroBgImage = getCareerAssetUrl('main_hero_bg-image.webp');
export const mainAboutBgImage = getCareerAssetUrl('main_about_bg-image.webp');
export const mainSystemBottomBgImage = getCareerAssetUrl('main_system_bottom-bg-image.svg');
export const mainVacanciesBg = getCareerAssetUrl('main_vacancies_bg.svg');
export const mainOfferBg = getCareerAssetUrl('main_offer_bg.svg');
export const mainHeroMobileBgImage = getCareerAssetUrl('main_hero_mobile-bg-image.webp');
export const ogImage = getCareerAssetUrl('og.png');
